import http from "./constants/http";
import resources from "./constants/resources";

// 회원 본인 인증
export const cerPhoneNumberCheck = async (body) => {
  const res = await http(resources.CERTIFICATION).post(body);
  const resData = {
    code: res?.data?.Code,
    data: res?.data?.Data,
  };
  return resData;
};

// 인증번호 검증
export const cerPhoneTokenCheck = async (body) => {
  const res = await http(resources.CERTIFICATION).post(body);
  const resData = {
    code: res?.data?.Code,
    data: res?.data?.Data,
  };
  return resData;
};
